import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import '../App.css';

const PrivacyPolicyRO = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If opened in new tab, close the window; otherwise navigate back
    if (window.history.length <= 2) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <img src="/epg_logo.png" alt="EPG Logo" className="logo-icon" />
          </div>
          <div className="header-buttons">
            <Button variant="outline" className="header-btn" onClick={handleBack}>
              Înapoi
            </Button>
          </div>
        </div>
      </header>

      {/* Privacy Policy Content */}
      <section className="contact-section" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="contact-container" style={{ maxWidth: '800px' }}>
          <h1 className="contact-title" style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>
            Politica de Confidențialitate
          </h1>
          <div style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            lineHeight: '1.8',
            fontSize: '1.1rem',
            textAlign: 'left'
          }}>
            <p style={{ marginBottom: '1.5rem' }}>
              Electrum Prosperity Group („EPG") respectă confidențialitatea dumneavoastră și este dedicat protejării informațiilor personale. Când vizitați site-ul nostru web, vă înregistrați sau interacționați cu serviciile noastre, este posibil să colectăm informații de bază, cum ar fi numele, adresa de e-mail sau detaliile de contact, exclusiv pentru a comunica cu dumneavoastră, pentru a furniza resurse și pentru a îmbunătăți serviciile noastre.
            </p>
            <p style={{ marginBottom: '1.5rem' }}>
              Prin utilizarea site-ului și serviciilor noastre, sunteți de acord cu această politică de confidențialitate. Dacă aveți întrebări sau nelămuriri cu privire la modul în care sunt gestionate informațiile dumneavoastră, vă rugăm să ne contactați direct.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyRO;
